/**
 * 카드결제 직접입력 (BottomSheet self-contained) — Card 페이지 전용.
 *
 * Card.js 가 인스턴스를 만들어 BS 의 ad-hoc adapter(객체 with init()) 로 넘긴다:
 *   $j.Ui.BS.open({
 *       target: new ManualPay(),
 *       data: { memberName, memberPhone, memberNo, onApply: ({obj, memo}) => {...} }
 *   });
 *
 * 작업구분/작업시간 은 화면 가운데 모달($j.Ui.JBModal)로 띄운다.
 */
const WORKTYPE_MODAL = 'card-worktype-modal';
const WORKTIME_MODAL = 'card-worktime-modal';

export default class ManualPay {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
        this.instMobi = null;

        this.worktype = '오전'; // 작업구분
        this.workhour = 4;      // 작업시간(숫자)
    }

    /**
     * BS 가 this.id, this.parent, this.data 주입 후 호출
     */
    init() {
        this.parent?.setTitle?.('카드결제할 내용 입력하기');
        $('#' + this.id).html(this.skeletonHtml());
        this.initCalendar();
        this.initHandler();
        this.refreshWorktype();
        this.refreshWorktime();
    }

    destroy() {
        if (this.instMobi) {
            try { this.instMobi.destroy?.(); } catch (e) {}
        }
        $j.Ui.JBModal.close(WORKTYPE_MODAL);
        $j.Ui.JBModal.close(WORKTIME_MODAL);
        $('#' + this.id).off();
    }

    skeletonHtml() {
        return `
<div class="manual-pay-wrap">
    <div class="manual-pay-row">
        <div class="leftTxt">작업날짜</div>
        <div class="rightTxt"><input type="text" readonly id="pm-date" placeholder="작업 날짜 선택"></div>
    </div>
    <div class="manual-pay-row">
        <div class="leftTxt">작업구분</div>
        <div class="rightTxt"><div class="fake-input" id="pm-worktype"></div></div>
    </div>
    <div class="manual-pay-row">
        <div class="leftTxt">작업시간</div>
        <div class="rightTxt"><div class="fake-input" id="pm-worktime"></div></div>
    </div>
    <div class="manual-pay-row">
        <div class="leftTxt">작업금액</div>
        <div class="rightTxt"><input type="tel" id="pm-price" data-amount-kor placeholder="숫자만 입력"></div>
    </div>
    <div class="manual-pay-row memo">
        <div class="leftTxt">메모</div>
        <div class="rightTxt"><textarea id="pm-memo" placeholder="현장주소 및 메모를 적어주세요"></textarea></div>
    </div>
    <div class="manual-pay-actions">
        <button type="button" class="btn-ok" id="pm-ok">확 인</button>
        <button type="button" class="btn-cancel" id="pm-cancel">취 소</button>
    </div>
</div>`;
    }

    initCalendar() {
        const $el = $('#pm-date');
        this.instMobi = $el.mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            buttons: [],
        }).mobiscroll('getInst');
    }

    initHandler() {
        const self = this;
        const root = '#' + this.id;

        $(root).on('click', '#pm-worktype', () => self.openWorktypeModal());
        $(root).on('click', '#pm-worktime', () => self.openWorktimeModal());
        $(root).on('input', '#pm-price', function () { $j.Common.Form.formatNumberInput(this); });
        $(root).on('click', '#pm-ok', () => self.apply());
        $(root).on('click', '#pm-cancel', () => self.parent?.close?.());
    }

    /* ============ 작업구분 (가운데 모달) ============ */

    openWorktypeModal() {
        const self = this;
        const types = ['하루', '오전', '오후', '시간', '야간'];
        const html = `<div class="card-choice-grid">${
            types.map(t => `<div class="choice ${t === self.worktype ? 'on' : ''}" data-type="${t}">${t}</div>`).join('')
        }</div>`;

        $j.Ui.JBModal.html(WORKTYPE_MODAL, html, '작업구분', {width: '300px'});

        $(`#${WORKTYPE_MODAL}`).off('click', '.choice').on('click', '.choice', function () {
            self.worktype = $(this).data('type');
            self.refreshWorktype();
            self.refreshWorktime();
            $j.Ui.JBModal.close(WORKTYPE_MODAL);
        });
    }

    /**
     * 작업구분 변경 시 기본 작업시간 규칙 (레거시 chekoutworktype)
     */
    refreshWorktype() {
        if (this.worktype === '하루') {
            this.workhour = 1;
        } else if (this.worktype === '오전' || this.worktype === '오후') {
            this.workhour = 4;
        } else {
            this.workhour = 1;
        }
        $('#pm-worktype').text(this.worktype);
    }

    /* ============ 작업시간 (가운데 모달) ============ */

    openWorktimeModal() {
        const self = this;
        const isDay = this.worktype === '하루';
        const unit = isDay ? '일' : '시간';
        const max = isDay ? 12 : 16;

        let choices = '';
        for (let i = 1; i <= max; i++) {
            choices += `<div class="choice ${i === self.workhour ? 'on' : ''}" data-hour="${i}">${i}${unit}</div>`;
        }
        $j.Ui.JBModal.html(WORKTIME_MODAL, `<div class="card-choice-grid">${choices}</div>`, '작업시간', {width: '300px'});

        $(`#${WORKTIME_MODAL}`).off('click', '.choice').on('click', '.choice', function () {
            self.workhour = parseInt($(this).data('hour'), 10);
            self.refreshWorktime();
            $j.Ui.JBModal.close(WORKTIME_MODAL);
        });
    }

    refreshWorktime() {
        const unit = this.worktype === '하루' ? '일' : '시간';
        $('#pm-worktime').text(this.workhour + unit);
    }

    /* ============ 확인 ============ */

    apply() {
        const memo = String($('#pm-memo').val() || '').trim();
        const date = String($('#pm-date').val() || '');
        let amount = String($('#pm-price').val() || '').replace(/,/g, '');
        amount = parseInt(amount, 10);
        if (isNaN(amount)) amount = 0;

        if (memo.length < 3) { alert('정보 부족\n현장 주소 또는 작업 관련 메모를 입력해 주세요'); return; }
        if (date.length !== 10) { alert('정보 부족\n작업 날짜를 선택해 주세요'); return; }
        if (amount < 1000) { alert('정보 부족\n금액을 숫자만으로 입력해 주세요(최소 1,000원 이상)'); return; }

        const obj = {
            order_num: 9999999,
            work_day: date,
            site_address: memo,
            car_workdaytype: '일',
            car_workhour: '1',
            car_price: amount,
            mem_name: this.data.memberName,
            mem_phone: this.data.memberPhone,
            order_member_num: -1,
            worker_owner_num: this.data.memberNo,
        };

        const memoText = this.worktype === '하루'
            ? '하루작업'
            : `${this.worktype} ${this.workhour}시간`;

        const cb = this.data?.onApply;
        this.parent.close();
        if (typeof cb === 'function') cb({obj, memo: memoText});
    }
}
